import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as orderActions from '../../../actions/orderActions';
import OrderModalStep from '../OrderModalStep/OrderModalStep';
import CodeField from '../../common/CodeField/CodeField';
import OrderSummary from '../OrderSummary/OrderSummary';
import './ConfirmationStep.less';

class ConfirmationStep extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleCodeSubmit = this.handleCodeSubmit.bind(this);

    this.state = {
      valid: true,
      validationRun: 0
    };
  }

  handleChange() {
    this.setState({valid: true});
  }

  handleCodeSubmit(code) {
    const {orderEntity, orderActions, onPrimaryAction} = this.props;
    orderActions.confirmOrder(orderEntity.id, code)
      .then(onPrimaryAction)
      .catch(() => {
        this.setState({
          valid: false,
          validationRun: this.state.validationRun + 1
        });
      });
  }

  render () {
    const {handleChange, handleCodeSubmit} = this;
    const {address, cartItems, onBack, onClose} = this.props;
    const {valid, validationRun} = this.state;

    return (
      <OrderModalStep className="confirmation-step"
        title="Potwierdzenie"
        primaryActionTitle="OK"
        primaryActionEnabled={false}
        onBack={onBack}
        onClose={onClose}>
        <div className="confirmation-code-group">
          <label>Wprowadź kod z wyslanego SMS:</label>
          <CodeField onChange={handleChange} onSubmit={handleCodeSubmit} valid={valid} validationRun={validationRun}/>
        </div>
        <aside>
          <OrderSummary address={address} cartItems={cartItems}/>
        </aside>
      </OrderModalStep>
    );
  }
}

ConfirmationStep.propTypes = {
  orderActions: PropTypes.object.isRequired,
  address: PropTypes.object,
  cartItems: PropTypes.array,
  orderEntity: PropTypes.object,
  onPrimaryAction: PropTypes.func,
  onBack: PropTypes.func,
  onClose: PropTypes.func
};

function mapStateToProps(state) {
  return {
    orderEntity: state.order.entity,
    address: state.address,
    cartItems: state.cart.cartItems
  };
}

function mapDispatchToProps(dispatch) {
  return {
    orderActions: bindActionCreators(orderActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationStep);



// WEBPACK FOOTER //
// ./src/components/OrderModal/ConfirmationStep/ConfirmationStep.js